import { createReducer, on } from '@ngrx/store';
import { ERP_LIST_MAP } from 'wflow-main-app/src/app/shared/__const/erp-list.const';
import { getOrg } from 'wflow-main-app/src/app/shared/utils/route.utils';
import { OrgData } from '../organizations/organizations.model';
import {
  ChangeIntegrationERP,
  LoadIntegration,
  LoadIntegrationItemsSuccess,
  LoadIntegrationSettings,
  ResetIntegration,
  SetAccountingItems,
  SetFailureIntegration,
  SetIntegrationSuccess,
  SetIntegrator,
  SetValidationItems,
  SettingIntegration,
  UpdateIntegrationItemsSuccess,
} from './integration.actions';
import { IntegrationItem, IntegrationState } from './integration.model';
import {
  integrationContextsInitState,
  integrationInitState,
} from './integration.state';

export const FindERPByCode = (code: string) => {
  let erp: IntegrationItem =
    ERP_LIST_MAP.get(code) ?? ERP_LIST_MAP.get('undefined');
  return erp || integrationInitState.erp;
};

export const IntegrationReducer = createReducer(
  integrationContextsInitState,

  /** Fetching */
  on(
    LoadIntegration,
    LoadIntegrationSettings,
    SettingIntegration,
    ChangeIntegrationERP,
    SetIntegrator,
    SetAccountingItems,
    SetValidationItems,
    settingOrgStart,
  ),

  /** Set ERP Integration */
  on(
    SetIntegrationSuccess,
    (state: OrgData<IntegrationState>, { orgId, data }) => {
      const newErp = FindERPByCode(data?.erp?.id);
      const extraction = data?.extraction?.integrator ? data?.extraction : null;

      return {
        ...state,
        [orgId]: {
          ...integrationInitState,
          ...state[orgId],
          erp: newErp,
          integration: {
            ...data?.erp,
          },
          extraction,
          status: !!data?.erp?.integrator,
          loading: false,
        },
      };
    },
  ),

  /** Set ERP & validation fields */
  on(
    LoadIntegrationItemsSuccess,
    (state: OrgData<IntegrationState>, { orgId, data }) => ({
      ...state,
      [orgId]: {
        ...integrationInitState,
        ...state[orgId],
        kinds: { ...data },
        accounting: {
          ...state[orgId].accounting,
          fields: data.IncomingInvoice.accounting,
        },
        loading: false,
      },
    }),
  ),

  /** Set ERP fields */
  on(
    UpdateIntegrationItemsSuccess,
    (state: OrgData<IntegrationState>, { orgId, data }) => ({
      ...state,
      [orgId]: {
        ...integrationInitState,
        ...state[orgId],
        accounting: {
          ...state[orgId].accounting,
          fields: data,
        },
        loading: false,
      },
    }),
  ),

  on(
    SetFailureIntegration,
    (state: OrgData<IntegrationState>, { orgId, data }) => ({
      ...state,
      [orgId]: {
        ...integrationInitState,
        ...state[orgId],
        error: data,
        loading: false,
      },
    }),
  ),

  on(ResetIntegration, (state: OrgData<IntegrationState>, { orgId }) => ({
    ...state,
    [orgId]: { ...integrationInitState },
  })),
);

function settingOrgStart<T extends Object = { orgId: string }>(
  state: OrgData<IntegrationState>,
  payload: T = null,
) {
  const orgId =
    ('orgId' in payload && (payload['orgId'] as string)) ?? getOrg();
  return {
    ...state,
    [orgId]: {
      ...integrationInitState,
      ...state[orgId],
      loading: true,
    },
  } as OrgData<IntegrationState>;
}
